<p-select
  [ngClass]="className"
  [disabled]="isDisabled"
  [style]="{ width: width + '%', height: height + 'px' }"
  [options]="data"
  [(ngModel)]="selectedValue"
  optionLabel="value"
  optionValue="id"
  filterBy="value"
  [filter]="true"
  [showClear]="showClear"
  [placeholder]="placeholder"
  name="selectedValue"
  appendTo="body"
  (onChange)="onClickSelectionChange()"
  [resetFilterOnHide]="true"
>
  <ng-template let-option pTemplate="item">
    <div class="flex align-items-center gap-2">
      <div>{{ option.value }}</div>
    </div>
  </ng-template>
</p-select>